import { render, staticRenderFns } from "./PagarComponent.vue?vue&type=template&id=0a1f2114&"
import script from "./PagarComponent.vue?vue&type=script&lang=js&"
export * from "./PagarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports